module.exports = __webpack_public_path__ + "img/angular.54557aa.png";